import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import { formatColor } from './PremioGeral';

export function PremioQualidade({ data, producaoTotal, ocultarNomes }) {
    const [qualidade, setQualidade] = useState([]);
    const ref = useRef();

    const handlePrint = useReactToPrint({
        content: () => ref.current
    });

    useEffect(() => {
        if (!data) return;
        let items = data.filter((element) => {
            return String(element.tipo) === '4';
        });

        setQualidade(items);
    }, [data]);

    const calcQualidade = (rowData) => {
        const prodGeral = Number(producaoTotal) || 0;
        const defeito = Number(rowData.metragem) || 0;
        
        if (prodGeral === 0 || defeito === 0) return "0,00%";
        
        const porcentagem = (defeito / prodGeral) * 100;
        return porcentagem.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + "%";
    };

    const totalMetragemDefeito = (() => {
        const item = data?.find(item => String(item.tipo) === '1' || String(item.tipo) === '4');
        return Number(String(item?.metragem || 0).replace('m', '').replace(',', '.'));
    })();

    return (
        <div>
            <Button 
                className="p-m-1"
                icon="pi pi-print"
                onClick={handlePrint}
            />
            
            <div ref={ref}>
                <h3>Qualidade</h3>
                <p style={{marginTop: '-15px', fontWeight: '600'}}>
                    Total Metragem Defeito: <span style={{ color: '#7a0000', fontWeight: 700 }}>{totalMetragemDefeito.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}m</span>
                </p>
                <p style={{marginTop: '-15px', fontWeight: '600'}}>
                    Total Metragem Produzida: <span style={{ color: '#00397a', fontWeight: 700 }}>{Number(producaoTotal || 0).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}m</span>
                </p>
                <DataTable
                    emptyMessage="Nenhum registro encontrado."
                    rowHover
                    stripedRows
                    size="small"
                    value={qualidade}
                >
                    {!ocultarNomes && (
                        <Column header="Colaborador" field="nome" sortable style={{ minWidth: "200px", width: "20%" }} />
                    )}
                    <Column header="Tipo" field="tipof" sortable />
                    <Column header="Metragem" field="metragem" sortable body={(r) => Number(r.metragem || 0).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + "m"} />
                    <Column header="Qualidade" body={calcQualidade} style={{ fontWeight: 'bold' }} />
                    <Column header="Prêmio de Qualidade" field="premio" sortable body={(rowData) => formatColor(rowData, 'premio')} />
                </DataTable>
            </div>
        </div>
    );
}
